<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import SubmittedData from "./finance-preplanning-dus.vue";
import LIBItems from "./dus-lib-items.vue";
import { required } from "vuelidate/lib/validators";
import { groupBy } from "lodash";
import PrintOptions from "@/components/modals/print-options.vue";
import OpcrLogs from "@/router/views/office/office-widgets/opcr-logs.vue";
import Swal from "sweetalert2";
export default {
    page: {
        title: "Submitted LIB",
    },
    components: {
      Layout,
      PageHeader,
      SubmittedData,
      PrintOptions,
      OpcrLogs,
      LIBItems,
    },
    data() {
        return {
            title: "Submitted LIB",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Submitted LIB",
                    active: true,
                },
            ],
            tableBusy: false,
            approvedBusy: false,
            approvedData: [],
            tableData: [],
            allocatedItems: [],
            allocationLoading: false,
            returnForm: {
              id: 0,
              remarks: "",
            },
            submitted: false,
        };
    },
    validations: {
      returnForm: { remarks: { required } },
    },
    async created() {
      this.getPosted(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
      this.getApproved(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
    },
    methods: {
        changeCycle(cycle){
          this.getPosted(cycle, this.$store.state.data.selectedCampus.id);
          this.getApproved(cycle, this.$store.state.data.selectedCampus.id);
        },
        changeCampus(campus){
          this.getPosted(this.$store.state.data.cycle, campus.id);
          this.getApproved(this.$store.state.data.cycle, campus.id);
        },
        getPosted(event, campusId) {
          this.tableBusy = true;
          this.$store
              .dispatch("preopcr/GetPostedFinanceOPCR", {cycle: event, campusId: campusId})
              .then((res) => {
                  this.tableBusy = false;
                  if(res.data.error){
                    return this.showToast(res.data.errorMessage, "error");
                  }
                  res.data.map(item => {
                    item.showApis = false;
                    item.apis = [];
                    item.loadApi = false;
                    item.showLibs = false;
                    item.libs = [];
                    item.loadLib = false;
                    item.apiSearch = '';
                  })
                  var grouped = groupBy(res.data, "deliveryUnitId");
                  var data = [];
                  for (var key in grouped) {
                    data.push({
                      deliveryUnitId: key,
                      deliveryUnit: grouped[key][0].deliveryUnit,
                      count: grouped[key].length,
                      opcrs: grouped[key],
                    });
                  }
                  this.tableData = data;
              })
              .catch((err) => {
                  this.tableBusy = false;
                  this.showToast("Something went wrong!", "error");
              });
        },
        getApproved(event, campusId) {
            this.approvedBusy = true;
            this.$store
                .dispatch("preopcr/GetApprovedFinanceOPCR", {cycle: event, campusId})
                .then((res) => {
                    this.approvedBusy = false;
                    this.tableBusy = false;
                    if(res.data.error){
                      return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                      item.showApis = false;
                      item.apis = [];
                      item.loadApi = false;
                      item.showLibs = false;
                      item.libs = [];
                      item.loadLib = false;
                      item.apiSearch = '';
                    })
                    var grouped = groupBy(res.data, "deliveryUnitId");
                    var data = [];
                    for (var key in grouped) {
                      data.push({
                        deliveryUnitId: key,
                        deliveryUnit: grouped[key][0].deliveryUnit,
                        count: grouped[key].length,
                        opcrs: grouped[key],
                      });
                    }
                    this.approvedData = data;
                })
                .catch((err) => {
                    this.approvedBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        returnOPCR(opcr, type){
          this.returnForm = {
            id: opcr.id,
            remarks: "",
            type: type,
          }
          this.$bvModal.show("return-modal");
        },
        async returnOPCRSubmit() {
            this.submitted = true;
            this.$v.returnForm.$touch();
            if (this.$v.returnForm.$invalid) {
                return;
            }
            await this.$store
                .dispatch("preopcr/ReturnFinancePreOpcr", this.returnForm)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    if(this.returnForm.type == "posted"){
                      this.$refs.postedData.removeOPCR(this.returnForm.id)
                    }else{
                      this.$refs.approvedData.removeOPCR(this.returnForm.id)
                    }
                    this.$bvModal.hide('return-modal');
                    this.showToast("Successfully returned", "success");
                })
                .catch((err) => {
                    console.log(err)
                    this.showToast("Something went wrong!", "error");
                });
        },
        async printOPCR({id, type}) {
          let apiUrl = "api/Report/PrePlanning/OPCR";
          if(type == 2){
            apiUrl = "api/Report/PrePlanning/OPCR/V2";
          }else if(type == 3){
            apiUrl = "api/Report/PrePlanning/OPCR/V3";
          }else if(type == 4){
            apiUrl = "api/Report/PrePlanning/OPCR/V4";
          }
          this.$refs.printOpt.putOptions({
            apiUrl: apiUrl,
            routeVariables: [id],
          });
          this.$bvModal.show("print-options-modal");
        },
        async printDULIB(id) {
          this.$refs.printOpt.putOptions({
            apiUrl: "api/Report/PrePlanning/LIB",
            routeVariables: [id],
          });
          this.$bvModal.show("print-options-modal");
        },
        async printPPMP({id, type}){
          if(type == 2){
            this.$refs.printOpt.putOptions({
              apiUrl: "api/Report/Procurement/Planning/PPMP/Report",
              routeVariables: [id],
            });
          }else{
            this.$refs.printOpt.putOptions({
              apiUrl: "api/Report/PrePlanning/PPMP/OPCR",
              routeVariables: [id],
            });
          }
          this.$bvModal.show("print-options-modal");
        },
        async printPPMPByApi({id, type}){
          this.$refs.printOpt.putOptions({
            apiUrl: type == 2 ? "api/Report/Procurement/Planning/PPMP/Api/Report" : "api/Report/PrePlanning/PPMP/API",
            routeVariables: [id],
          });
          this.$bvModal.show("print-options-modal");
        },
        async printLIB(selectedFS){
          this.$refs.printOpt.putOptions({
            apiUrl: "api/Report/PrePlanning/FundSource/LIB",
            routeVariables: [this.$store.state.data.cycle, selectedFS],
          });
          this.$bvModal.show("print-options-modal");
        },
        printPRE({url, routeVar}){
          this.$refs.printOpt.putOptions({
            apiUrl: url,
            routeVariables: routeVar,
          });
          this.$bvModal.show("print-options-modal");
        },
        printAPP(){
          this.$refs.printOpt.putOptions({
            apiUrl: "api/Report/Preplanning/APP",
            routeVariables: [this.$store.state.data.selectedCampus.id, this.$store.state.data.cycle],
          });
          this.$bvModal.show("print-options-modal");
        },
        viewLogs(opcr){
          this.$bvModal.show('opcr-logs-modal');
          this.$refs.opcrLogs.modalTitle = `${opcr.title} Logs`
          this.$refs.opcrLogs.getData(opcr);
        },
        viewItems(row){
          this.$refs.libItems.selectedBudgetAmount = row.balance;
          this.$refs.libItems.getResourceDetails(row.id);
          this.$bvModal.show('dus-lib-items-modal');
        },
        async importThisAPI(api){
          Swal.fire({
            title: "Are you sure?",
            text: "You want to import this API?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Yes, import it!",
          }).then(async (result) => {
            if (result.value) {
              await this.$store
                .dispatch("preopcr/ImportAPI", api.id)
                  .then((res) => {
                      if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                      }
                      api.imported = true;
                      this.showToast("API successfully imported", "success");
                  })
                  .catch((err) => {
                      this.showToast("Something went wrong!", "error");
                  });
            }
          });
        },
        async allocatedToDepartment(accountGrp){
          this.$bvModal.show('allocated-departments-modal');
            this.allocationLoading = true;
            this.allocatedItems = [];
            await this.$store
                .dispatch("departmentplanningbudgetitem/GetAllBudgetItem", accountGrp.id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.allocatedItems = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            this.allocationLoading = false;
        },
        
    },
};
</script>
<template>
  <Layout @changeCycle="changeCycle" @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <b-modal
        id="return-modal"
        title="Return Remarks"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form @submit.prevent="returnOPCRSubmit" class="needs-validation">
            <b-row>
                <b-col>
                    <div class="mb-3">
                        <label for="description">Remarks </label>
                        <textarea
                            id="description"
                            rows="3"
                            v-model="returnForm.remarks"
                            placeholder="Enter Remarks..."
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.returnForm.remarks.$error,
                            }"
                        ></textarea>
                        <div
                            v-if="submitted && $v.returnForm.remarks.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.returnForm.remarks.required"
                                >This value is required.</span
                            >
                        </div>
                    </div>
                </b-col>
            </b-row>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    Return LIB
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('return-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
    <b-modal
      id="allocated-departments-modal"
      title="Allocated Departments"
      size="lg"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <div>
          <table class="table table-striped table-bordered">
              <thead>
                  <tr>
                      <th>Department</th>
                      <th>Amount</th>
                  </tr>
              </thead>
              <tbody>
                  <template v-if="allocationLoading">
                      <tr>
                          <td colspan="100%" class="text-center">
                              <div class="d-flex justify-content-center align-items-center">
                                  <div class="preloader-component me-2">
                                      <div class="status">
                                          <div class="spinner-chase w-20px h-20px">
                                              <div class="chase-dot" v-for="x in 5" :key="x"></div>
                                          </div>
                                      </div>
                                  </div>
                                  <strong>Loading...</strong>
                              </div>
                          </td>
                      </tr>
                  </template>
                  <template v-else>
                      <tr v-for="(item, index) in allocatedItems" :key="index">
                          <td>{{ item.department.departmentName }}</td>
                          <td>{{ formatCurrency(item.amount) }}</td>
                      </tr>
                      <tr v-if="allocatedItems.length == 0">
                          <td colspan="100%" class="text-center">No data found</td>
                      </tr>
                  </template>
              </tbody>
          </table>
      </div>
    </b-modal>
    <b-tabs content-class="pt-3 pb-3 text-muted">
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Posted</span>
        </template>
        <SubmittedData 
          :items="tableData" 
          ref="postedData"
          :forApproval="true" 
          @return-opcr="returnOPCR($event, 'posted')"
          @print-ppmp-api="printPPMPByApi"
          @print-ppmp="printPPMP"
          @print-opcr="printOPCR"
          @print-du-lib="printDULIB"
          @viewLogs="viewLogs"
          @viewItems="viewItems"
          @printPRE="printPRE"
          @printLIB="printLIB"
          @printAPP="printAPP"
          @allocated-departments="allocatedToDepartment"
        />
      </b-tab>
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Approved</span>
        </template>
        <SubmittedData 
          :items="approvedData" 
          ref="approvedData"
          :forApproval="false"
          @return-opcr="returnOPCR($event, 'approved')"
          @print-ppmp-api="printPPMPByApi"
          @print-opcr="printOPCR"
          @print-du-lib="printDULIB"
          @viewLogs="viewLogs"
          @viewItems="viewItems"
          @import-api="importThisAPI"
          @print-ppmp="printPPMP"
          @allocated-departments="allocatedToDepartment"
        />
      </b-tab>
    </b-tabs>
    <print-options ref="printOpt"></print-options>
    <opcr-logs ref="opcrLogs"></opcr-logs>
    <LIBItems ref="libItems"/>
  </Layout>
</template>